// extracted by mini-css-extract-plugin
export default {"no_content":"styles_no_content__6GUKn"};